__turbopack_context__.v({
  "ProseMirror": "markdown-native-module-scss-module__vVcgPW__ProseMirror",
});
